/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCrop(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M6.136.25a.75.75 0 01.744.756L6.843 5.33 16 5.25A2.75 2.75 0 0118.75 8v9.25H23a.75.75 0 010 1.5h-4.25V23a.75.75 0 01-1.5 0v-4.25H8A2.75 2.75 0 015.25 16v-.007l.08-9.15-4.324.037a.75.75 0 11-.012-1.5l4.348-.038L5.38.994A.75.75 0 016.136.25zm.694 6.58l-.08 9.173A1.25 1.25 0 008 17.25h9.25V8a1.25 1.25 0 00-1.247-1.25l-9.173.08z'
        />
      </g>
      <defs>
        <clipPath id='crop_svg__clip0_126_10521'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgCrop;
